import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useSignMessage } from "wagmi";
import { parseSignatureError } from "../../lib/errors";
import { useWithConnectorErrorRetry } from "./useWithConnectorErrorRetry";
export const useEvmSignFunction = () => {
  const $ = _c(3);
  const {
    signMessageAsync: signMessage
  } = useSignMessage();
  const withConnectorErrorRetry = useWithConnectorErrorRetry();
  let t0;
  if ($[0] !== signMessage || $[1] !== withConnectorErrorRetry) {
    t0 = async variables => {
      ;
      try {
        const signature = await withConnectorErrorRetry(async () => await signMessage({
          message: variables.message,
          account: variables.address,
          connector: variables.connector?.baseConnector
        }));
        return signature;
      } catch (t1) {
        const err = t1;
        const error = err;
        const externalError = parseSignatureError(error);
        throw externalError;
      }
    };
    $[0] = signMessage;
    $[1] = withConnectorErrorRetry;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const sign = t0;
  return sign;
};